// const G_API = "https://classroom.googleapis.com/v1";
// const API = "https://radiant-fortress-88014.herokuapp.com";
// module.exports = { G_API, API };

const G_API = "https://classroom.googleapis.com/v1";
// const API = "http://localhost:8000";
const API = "https://peer-learning-iiitv.herokuapp.com";
module.exports = { G_API, API };